// @flow

const Permissions = {
  // Client
  CLIENT_PROFILE_CREATE: 'client_profile_create',
  CLIENT_PROFILE_VIEW: 'client_profile_view',
  CLIENT_PROFILE_MERGE: 'client_profile_merge',
  CLIENT_PROFILE_DELETE: 'client_profile_delete',
  CLIENT_PROFILE_LIST_VIEW: 'report_data_view_client_list',
  // Building
  PACKET_FORM_BUILDING_CREATE: 'packet_form_building_create',
  PACKET_FORM_BUILDING_DISABLE: 'packet_form_building_disable',
  PACKET_FORM_BUILDING_DELETE: 'packet_form_building_delete',
  // Submission
  PACKET_FORM_SUBMISSION_VIEW: 'packet_form_submission_view',
  PACKET_FORM_SUBMISSION_SEND: 'packet_form_submission_send',
  PACKET_FORM_SUBMISSION_ARCHIVE: 'packet_form_submission_archive',
  PACKET_FORM_SUBMISSION_DELETE: 'packet_form_submission_delete',
  // Export
  PACKET_FORM_SUBMISSION_EXPORT_PDF: 'packet_form_submission_export_pdf',
  PACKET_FORM_SUBMISSION_EXPORT_CSV: 'packet_form_submission_export_csv',
  // Report
  REPORT_DATA_VIEW_SUBMISSION_REPORT: 'report_data_view_submission_report',
  // Settings
  SETTINGS_GENERAL_SETTING: 'settings_general_setting',
  SETTINGS_AUTOMATION: 'settings_automation',
  SETTINGS_INTEGRATION: 'settings_integration',
  SETTINGS_TEAM_USER: 'settings_team_user',
  SETTINGS_USER_ASSIGNED_FORM_VISIBILITY:
    'settings_user_assigned_form_visibility',
}

export default Permissions
